/* eslint-disable no-restricted-syntax */
/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
/* eslint-disable quote-props */
document.addEventListener(
  'shopify:inspector:activate',
  handleInspectorActivate,
);

function handleInspectorActivate() {
  // (window.themeEditorConfig?.featured_product_grid || []).forEach((item) => {
  //   handleFeaturedProductGridInspector(
  //     item.sectionId,
  //   );
  // });
}

document.addEventListener('shopify:section:load', handleSectionLoad);

function handleSectionLoad(event) {
  const { sectionId } = event.detail;
  const sectionHandlers = {};

  if (window.themeEditorConfig?.evereve_image_with_text_overlay?.sectionId) {
    sectionHandlers[window.themeEditorConfig.evereve_image_with_text_overlay.sectionId] = handleEvereveImageWithTextOverlay;
  }

  const handler = Object.keys(sectionHandlers).find((key) => sectionId.includes(key));

  if (!handler) {
    console.log('No handler found for this section. Exiting.');
    return;
  }

  sectionHandlers[handler](sectionId);
}

function handleEvereveImageWithTextOverlay(sectionId) {
  const sectionElement = document.getElementById(`shopify-section-${sectionId}`);
  const elements = sectionElement.querySelectorAll('.heading-block');

  const ro = new ResizeObserver((entries) => {
    for (const entry of entries) {
      const { width } = entry.contentRect;
      entry.target.style.setProperty('--self-width', `${width}px`);
    }
  });

  elements.forEach((el) => ro.observe(el));
}
